// extracted by mini-css-extract-plugin
export default {"container":"LangSwitcher_container__rtMYI","current":"LangSwitcher_current__yCqDA","containerUnhover":"LangSwitcher_containerUnhover__YRaVL"};